import api from "../../utils/ApiConfig";

export const fetchPartnerApiCalls = async (page = 1, searchTerm = "", filters = {}) => {
  try {
    const response = await api.get(`/bo/partner-api-calls`, {
      params: {
        page: page,
        per_page: 50,
        endpoint: searchTerm,
        ...filters,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching partner API calls:", error);
    throw error;
  }
};

export const fetchPartners = async () => {
  try {
    const response = await api.get(`/bo/partners`);
    return response.data;
  } catch (error) {
    console.error("Error fetching partners:", error);
    throw error;
  }
};
